import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import swal from "sweetalert";

import firebase from "../../../firebase/firebase";
import "./CareerDetail.css";

export default function CareerDetail(props) {
  let { id } = useParams();
  useEffect(() => {
    console.log("role : ", id);
  }, []);

  const [emailId, setemailId] = useState("");
  const [inputFile, setinputFile] = useState(null);
  const storageRef = firebase.storage().ref();
  const firestore = firebase.firestore();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(emailId, inputFile["name"]);
    try {
      // var storageRef = storage.ref();
      var spaceRef = storageRef.child(`images/${inputFile["name"]}`);
      spaceRef
        .put(inputFile)
        .then(async (res) => {
          firestore
            .collection("careerForm")
            .add({
              emailId: emailId,
              imgUrl: await spaceRef.getDownloadURL(),
            })
            .then((res) => {
              console.log("response after ading", res);
              swal(
                "Question added sucessfully!",
                "Wait for someone to answer",
                "success"
              );
            })
            .catch((err) => {
              console.log("error while adding question ", err);
            });
        })
        .catch((err) => {
          console.log("error while uploading", err);
        });
    } catch (err) {
      console.log("Error while uploading file", err);
    }
  };
  const handleChange = (e) => {
    if (e.target.name === "emailId") {
      setemailId(e.target.value);
    } else if (e.target.name === "inputFile") {
      setinputFile(e.target.files[0]);
    }
  };

  if (id === "react-development") {
    return (
      <div>
        <div className="outer-career-detail">
          <div className="career-detail-card">
            <h2 className="career-detail-heading">
              ReactJS Development Internship in Pune at Scrobits Technologies
            </h2>
            {/* job role */}
            <h6>Scrobits Technologies</h6>
            <p>Pune</p>
            <div className="career-detail-timeline">
              <div>
                <h6>Start Date</h6>
                <small>Immediately</small>
              </div>
              <div>
                <h6>Duration</h6>
                <small>6 Months</small>
              </div>

              <div>
                <h6>Start Date</h6>
                <small>18 March 22</small>
              </div>
            </div>
            <p>Internship with job offer</p>
            {/* day to day tasks */}
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            <h3>About the job role</h3>
            <p>Selected intern's day-to-day responsibilities include:</p>
            <ol>
              <li>
                Have good knowledge and work experience of axios and fetch.
              </li>
              <li>Build exciting apps under the guidance of seniors</li>
              <li>Build dynamic data-friendly websites</li>
              <li>
                Use the latest versions of ReactJS and the latest methodologies
                of JavaScript to upgrade things as per possibilities
              </li>
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* skills required */}
            <h3>Skills Required</h3>
            <div className="skills-required">
              <div>CSS</div>
              <div>HTML</div>
              <div>Javascript</div>
              <div>ReactJS</div>
              <div>Redux</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Who can apply */}
            <h3>Who can apply</h3>
            <p>Only those candidate can apply who:</p>
            <ol>
              <li>Are available for full time (in-office) internship</li>
              <li>
                Can start the internship between 4th Feb'22 and 11th Mar'22
              </li>
              <li>Are available for duration of 6 months</li>
              <li>Have relevant skills and interests</li>* Women wanting to
              start/restart their career can also apply.
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Perks */}
            <h3 className="perk-heading">Perks</h3>
            <div className="perks">
              <div>Certificate</div>
              <div>Letter of recommendation</div>
              <div>Flexible work hours</div>
              <div>Job offer</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* <h3>Number Of openings</h3>
          <h6>2</h6> */}

            <form className="scrobitsQuoteForm" onSubmit={handleSubmit}>
              <p>To join us</p>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Email Id <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="email"
                  id="emailId"
                  className={"formInput"}
                  placeholder="user@gmail.com"
                  value={emailId}
                  name="emailId"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Upload Resume <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="file"
                  className={"formInput"}
                  name="inputFile"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroupBtn"}>
                <input type="submit" className={"formInput"} value="Submit" />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  } else if (id === "sales&marketing") {
    return (
      <div>
        <div className="outer-career-detail">
          <div className="career-detail-card">
            <h2 className="career-detail-heading">
              Business Development (Sales) and Marketing internship in Pune at
              Scrobits Technologies
            </h2>
            {/* job role */}
            <h6>Scrobits Technologies</h6>
            <p>Pune</p>
            <div className="career-detail-timeline">
              <div>
                <h6>Start Date</h6>
                <small>Immediately</small>
              </div>
              <div>
                <h6>Duration</h6>
                <small>6 Months</small>
              </div>

              <div>
                <h6>Start Date</h6>
                <small>18 March 22</small>
              </div>
            </div>
            <p>Internship with job offer</p>
            {/* day to day tasks */}
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            <h3>About the job role</h3>
            <p>Selected intern's day-to-day responsibilities include:</p>
            <ol>
              <li>
                Collect quantitative and qualitative data from marketing
                campaigns.
              </li>
              <li>Perform market analysis and research on competition</li>
              <li>
                Studying and analyzing leads, Companies, Startups, and Startup
                ideas
              </li>
              <li>
                Assist in marketing and advertising promotional activities (e.g.
                social media, direct mail, and web).
              </li>
              <li>Prepare promotional presentations.</li>
              <li>Writing attractive and intuitive Emails</li>
              <li>
                Manage and update company database and customer relationship
                management systems (CRM)
              </li>
              <li>A team player with a high level of dedicationM)</li>
              <li>Good computer skills (MS Office)</li>
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* skills required */}
            <h3>Skills Required</h3>
            <div className="skills-required">
              <div>Good communication</div>
              <div>MS Office</div>
              <div>Active listening </div>
              <div>Social media skills</div>
              <div>Email Writing</div>
              <div>Problem-solving skills</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Who can apply */}
            <h3>Who can apply</h3>
            <p>Only those candidate can apply who:</p>
            <ol>
              <li>Are available for full time (in-office) internship</li>
              <li>
                Can start the internship between 4th Feb'22 and 11th Mar'22
              </li>
              <li>Are available for duration of 6 months</li>
              <li>Have relevant skills and interests</li>* Women wanting to
              start/restart their career can also apply.
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Perks */}
            <h3 className="perk-heading">Perks</h3>
            <div className="perks">
              <div>Certificate</div>
              <div>Letter of recommendation</div>
              <div>Stipend (To be discussed in person)</div>
              <div>Flexible work hours</div>
              <div>Job offer</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* <h3>Number Of openings</h3>
          <h6>2</h6> */}

            <form className="scrobitsQuoteForm" onSubmit={handleSubmit}>
              <p>To join us</p>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Email Id <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="email"
                  id="emailId"
                  className={"formInput"}
                  placeholder="user@gmail.com"
                  value={emailId}
                  name="emailId"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Upload Resume <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="file"
                  className={"formInput"}
                  name="inputFile"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroupBtn"}>
                <input type="submit" className={"formInput"} value="Submit" />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  } else if (id === "flutter-development") {
    return (
      <div>
        <div className="outer-career-detail">
          <div className="career-detail-card">
            <h2 className="career-detail-heading">
              Flutter Development in Pune at Scrobits Technologies
            </h2>
            {/* job role */}
            <h6>Scrobits Technologies</h6>
            <p>Pune</p>
            <div className="career-detail-timeline">
              <div>
                <h6>Start Date</h6>
                <small>Immediately</small>
              </div>
              <div>
                <h6>Duration</h6>
                <small>6 Months</small>
              </div>

              <div>
                <h6>Start Date</h6>
                <small>18 March 22</small>
              </div>
            </div>
            <p>Internship with job offer</p>
            {/* day to day tasks */}
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            <h3>About the job role</h3>
            <p>Selected intern's day-to-day responsibilities include:</p>
            <ol>
              <li>
                Design & implement new app modules based on the product
                requirements using the Flutter framework
              </li>
              <li>Build reusable code and libraries for future use.</li>
              <li>Build user interfaces designed by UI/UX designers</li>
              <li>Integrate various APIs from third parties.</li>
              <li>
                Debug existing apps components, fix issues, and avoid
                regressions.
              </li>
              <li>
                Collaborate closely with the teams of UI/UX designers, PMs, QAs,
                and other developers.
              </li>
              <li>
                Manage and update company database and customer relationship
                management systems (CRM)
              </li>
              <li>A team player with a high level of dedication</li>
              <li>
                Participate in software architecture, design discussions, and
                code reviews.
              </li>
              <li>Follow the company guidelines and best practices.</li>
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* skills required */}
            <h3>Skills Required</h3>
            <div className="skills-required">
              {/* <div>Understanding of OOP concepts and SOLID Principles.</div>
              <div>
                Must have built & published at least an Android and/or iOS app
                with Flutter.
              </div>
              <div>
                Working experience in mobile development Android or iOS.
              </div>
              <div>Experience with third-party libraries and APIs.</div> */}
              <div>Flutter</div>
              <div>State management</div>
              <div>Good knowledge of Git.</div>
              <div>Good Knowledge of Dart</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Who can apply */}
            <h3>Who can apply</h3>
            <p>Only those candidate can apply who:</p>
            <ol>
              <li>Are available for full time (in-office) internship</li>
              <li>
                Can start the internship between 4th Feb'22 and 11th Mar'22
              </li>
              <li>Are available for duration of 6 months</li>
              <li>Have relevant skills and interests</li>* Women wanting to
              start/restart their career can also apply.
            </ol>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* Perks */}
            <h3 className="perk-heading">Perks</h3>
            <div className="perks">
              <div>Certificate</div>
              <div>Letter of recommendation</div>
              <div>Stipend (To be discussed in person)</div>
              <div>Flexible work hours</div>
              <div>Job offer</div>
            </div>
            <hr style={{ marginTop: "3%", marginBottom: "3%" }} />
            {/* <h3>Number Of openings</h3>
          <h6>2</h6> */}

            <form className="scrobitsQuoteForm" onSubmit={handleSubmit}>
              <p>To join us</p>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Email Id <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="email"
                  id="emailId"
                  className={"formInput"}
                  placeholder="user@gmail.com"
                  value={emailId}
                  name="emailId"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroup"}>
                <label htmlFor="fName" className={"formLabel"}>
                  Upload Resume <span className={"red"}>*</span>
                </label>
                <input
                  required
                  type="file"
                  className={"formInput"}
                  name="inputFile"
                  onChange={handleChange}
                />
              </div>
              <div className={"formGroupBtn"}>
                <input type="submit" className={"formInput"} value="Submit" />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  } else {
    return <div>Hello</div>;
  }
}
